import { motion } from 'framer-motion';

const Loader = () => {
    return (
        <div className="flex items-center justify-center min-h-[80vh]">
            <motion.div
                className="mr-2 h-10 w-10 animate-spin rounded-full border-2 border-current border-t-transparent"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.2 }}
            />
        </div>
    )
}

export default Loader;